

import React, { useState, useRef, useEffect } from "react";
import Header from "../Header/header";
import { IoFilterSharp } from "react-icons/io5";
import { FaFilePdf } from "react-icons/fa";
import { Dropdown, Table, Button } from "react-bootstrap";
import { FaChevronDown, FaEye } from "react-icons/fa";
import pdfimage from "../images/pdf_downlaod.png";
import { FaSearch } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaRegCalendarAlt } from "react-icons/fa";
import { FaPlus } from "react-icons/fa";
import { FaCirclePlus } from "react-icons/fa6";
import pdf_img from "../images/pdf_downlaod.png";
import random_pdf from "../images/dummy-pdf_2.pdf";
import DescriptionIcon from "@mui/icons-material/Description";

import {
  GetAllGetQueryData,
  updateBatchInvoiceStatus,
  updateBatchFinanceStatus,
} from "../../api/api";
import { Circles } from "react-loader-spinner";
import "react-toastify/dist/ReactToastify.css";
import QuaryPopUp from "./QuaryPopUp";
import { IconButton } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import GlobalSearchhook from "../Review batches/GlobalSearchhook";

function QueryCases() {
  const [invoicesData, setInvoicesData] = useState([]);
  console.log(invoicesData, "get all hold data");
  const [vendorSearch, setVendorSearch] = useState("");
  const [srnSearch, setSrnSearch] = useState("");
  const [searchInvoiceNo, setSeachInvoiceNo] = useState("");
  const [batchSearch, setBatchSearch] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRowData, setSelectedRowData] = useState(null);
  console.log("lala", selectedRowData);
  const [showHoldModal, setShowHoldModal] = useState(false);
  const itemsPerPage = 10;
  const dateInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const serviceProviderName = localStorage.getItem("ServiceProviderName");
  const user = JSON.parse(localStorage.getItem("user") || "null");
  const isNetworkRole = user?.role === "NetworkAdmin" || user?.role === "NetworkSubAdmin" || user?.role === "Finance";

  const invoiceOptions = [
    "Invoice",
    "Approved",
    "Hold",
    "Rejected",
    "Submitted",
    "Partial Approved",
    "Partial Finalized",
  ];
  const financeOptions = [
    "Paid",
    "Approved",
    "Hold",
    "Query",
    "Validate",
    "Payment Scheduled",
    "Partial Payment",
    "Bank Reject",
    "Rejected",
  ];

  const vendorList = Array.isArray(invoicesData)
    ? invoicesData.map(({ vendorName, srnNo }) => ({ vendorName, srnNo }))
    : [];
  const { handleSearch, searchText, setSearchText } = GlobalSearchhook()

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case "Batch":
        return "batch_badge_orange";
      case "Approved":
        return "approved_badge_green";
      case "approved":
        return "approved_badge_green";
      case "Submitted":
        return "submitted_badge_red";
      case "Invoice":
        return "invoice_badge_blue";
      case "hold":
        return "batch_badge_orange";
      case "Hold":
        return "batch_badge_orange";
      case "Rejected":
        return "rejected_badge_red";
      case "rejected":
        return "rejected_badge_red";
      case "Paid":
        return "paid_badge_red";
      case "paid":
        return "paid_badge_red";
      case "Query":
        return "query_badge_red";
      case "Partial Payment":
        return "partial_badge_red";
      case "Partial Approved":
        return "partial_approved_badge_red";
      case "query":
        return "query_badge_red";
      case "bank":
        return "bank_badge";
      default:
        return "badge-gray";
    }
  };

  const handleIconClick = () => {
    dateInputRef.current?.setFocus();
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevious = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const parseAPIDate = (dateStr) => {
    if (!dateStr) return null;

    const parts = dateStr.trim().split(" ");
    if (parts.length < 3) return null;

    const monthStr = parts[0];
    const day = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);

    const monthMap = {
      Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
      Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
    };

    const month = monthMap[monthStr];
    if (month === undefined || isNaN(day) || isNaN(year)) return null;

    return new Date(year, month, day);
  };

  const isSameLocalDay = (a, b) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();

  const filteredInvoices = Array.isArray(invoicesData)
    ? invoicesData.filter((invoice) => {
      const vendorMatch = vendorSearch
        ? invoice.vendorName?.toLowerCase().includes(vendorSearch.toLowerCase())
        : true;
      const invoiceNoMatch = searchInvoiceNo
        ? invoice.invoiceNo?.toLowerCase().includes(searchInvoiceNo.toLowerCase())
        : true;
      const batchMatch = batchSearch
        ? String(invoice.batchNo).includes(batchSearch)
        : true;
      const dateMatch = selectedDate
        ? (() => {
          const apiDate = parseAPIDate(invoice.invoiceDate);
          return apiDate && isSameLocalDay(apiDate, selectedDate);
        })()
        : true;
      const serviceProviderMatch = isNetworkRole
        ? true
        : (serviceProviderName ? invoice.vendorName?.toLowerCase() === serviceProviderName?.toLowerCase() : true);

      return vendorMatch && invoiceNoMatch && batchMatch && dateMatch && serviceProviderMatch;
    })
    : [];

  useEffect(() => {
    setCurrentPage(1);
  }, [vendorSearch, searchInvoiceNo, batchSearch, selectedDate, serviceProviderName]);

  const totalPages = Math.ceil(filteredInvoices.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentInvoices = filteredInvoices.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const handleInvoiceStatusChange = async (index, newStatus) => {
    const globalIndex = indexOfFirstItem + index;
    const selectedInvoice = invoicesData[globalIndex];
    const batchNo = selectedInvoice?.batchNo;

    try {
      const reason = newStatus === "Rejected" ? "Some rejection reason" : "";

      const response = await updateBatchInvoiceStatus({
        batchNo,
        status: newStatus,
        reason,
      });

      setInvoicesData((prev) =>
        prev.map((item, i) =>
          i === globalIndex
            ? {
              ...item,
              invoiceStatus: newStatus,
              financeStatus: newStatus === "Approved" ? "Submitted" : "",
            }
            : item
        )
      );

      toast.success("Invoice status updated successfully!", {
        position: "top-right",
        autoClose: 3000,
      });
    } catch (err) {
      toast.error("Failed to update invoice status.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  const handleFinanceStatusChange = async (index, newStatus) => {
    const globalIndex = indexOfFirstItem + index;
    const selectedInvoice = invoicesData[globalIndex];
    const batchNo = selectedInvoice?.batchNo;

    try {
      const reason = newStatus === "Rejected" ? "Finance rejected" : "";

      const response = await updateBatchFinanceStatus({
        batchNo,
        status: newStatus,
        reason,
      });

      setInvoicesData((prev) =>
        prev.map((item, i) =>
          i === globalIndex
            ? {
              ...item,
              financeStatus: newStatus,
              invoiceStatus:
                newStatus !== "Approved" ? "Hold" : item.invoiceStatus,
            }
            : item
        )
      );

      toast.success("Finance status updated successfully!", {
        position: "top-right",
        autoClose: 3000,
      });
    } catch (err) {
      toast.error("Failed to update finance status.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  const handleViewRow = (invoice) => {
    navigate("/queryCasesPage", { state: { invoice } });
  };

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const data = await GetAllGetQueryData();
        console.log("This is data ", data);
        if (Array.isArray(data.dataItems)) {
          setInvoicesData(data.dataItems);
        } else {
          setInvoicesData([]);
        }
      } catch (err) {
        console.error("Failed to load invoice data", err);
        setInvoicesData([]);
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, []);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  return (
    <div>
      <ToastContainer />
      <div className="container mt-4">
        <div className="netwrok_table_main_content">
          <div className="d-flex justify-content-between network_filter_div">
            <h5 className="fw-bold m-0">Query Cases</h5>
          </div>
          <div className="d-flex justify-content-between network_filter_div">
            <div className="d-flex justify-content-between align-items-center all_search_input">
              <div
                className="review_batch_seach input-group"
                style={{ maxWidth: "280px" }}
              >
                <div className="fa_search_main">
                  <span className="input-group-text bg-light fasearch">
                    <FaSearch className="text-muted" />
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control bg-light border-start-0"
                  placeholder="Search by Vendor Name"
                  value={vendorSearch}
                  onChange={(e) => setVendorSearch(e.target.value)}
                  style={{ borderLeft: "none", boxShadow: "none" }}
                />
              </div>
              <div
                className="review_batch_seach input-group"
                style={{ maxWidth: "240px" }}
              >
                <div className="fa_search_main">
                  <span className="input-group-text bg-light fasearch">
                    <FaSearch className="text-muted" />
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control bg-light border-start-0"
                  placeholder="Search by Invoice No"
                  value={searchInvoiceNo}
                  onChange={(e) => setSeachInvoiceNo(e.target.value)}
                  style={{ borderLeft: "none", boxShadow: "none" }}
                />
              </div>
              <div
                className="review_batch_seach input-group"
                style={{ maxWidth: "240px" }}
              >
                <div className="fa_search_main">
                  <span className="input-group-text bg-light fasearch">
                    <FaSearch className="text-muted" />
                  </span>
                </div>
                <input
                  type="number"
                  className="form-control bg-light border-start-0"
                  placeholder="Search by Batch No"
                  value={batchSearch}
                  onChange={(e) => setBatchSearch(e.target.value)}
                  style={{ borderLeft: "none", boxShadow: "none" }}
                />
              </div>
              <div
                className="review_batch_seach input-group"
                style={{ maxWidth: "240px", marginRight: "10px" }}
              >
                <div className="fa_search_main">
                  <span className="input-group-text bg-light fasearch">
                    <FaSearch className="text-muted" />
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control bg-light border-start-0"
                  placeholder="global Search"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                  style={{ borderLeft: "none", boxShadow: "none" }}
                />

              </div>
            </div>

            <div className="d-flex justify-content-between all_search_input">
              <div
                className="custom_date_wrapper review_batch_seach"
                style={{ maxWidth: "240px" }}
              >
                <DatePicker
                  ref={dateInputRef}
                  selected={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  dateFormat="dd-MM-yyyy"
                  placeholderText="dd-mm-yyyy"
                  className="custom-date-input"
                />
                <span className="calendar-icon" onClick={handleIconClick}>
                  <FaRegCalendarAlt />
                </span>
              </div>
            </div>
          </div>
          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "200px" }}
            >
              <Circles
                height="60"
                width="60"
                color="#FE850E"
                ariaLabel="circles-loading"
                visible={true}
              />
            </div>
          ) : (
            <div className="table-responsive mt-3">
              <Table className="bg-white text-center border-0 network_table">
                <thead style={{ backgroundColor: "#EEF4FF" }}>
                  <tr className="text-dark fw-semibold table_th_border">
                    <th className="border-start" style={{ whiteSpace: "nowrap" }}>
                      View
                    </th>
                    <th style={{ whiteSpace: "nowrap" }}>Log</th>
                    <th
                      onClick={() => handleSort("batchNo")}
                      style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                    >
                      Batch no {sortConfig.key === "batchNo" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                    </th>
                    <th
                      onClick={() => handleSort("vendorName")}
                      style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                    >
                      Vendor Name {sortConfig.key === "vendorName" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                    </th>
                    <th
                      onClick={() => handleSort("caseCount")}
                      style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                    >
                     Total Case Count {sortConfig.key === "caseCount" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                    </th>
                    <th
                      onClick={() => handleSort("totalRepairCharges")}
                      style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                    >
                      Total Repair Charges {sortConfig.key === "totalRepairCharges" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                    </th>
                    <th
                      onClick={() => handleSort("totalServiceCharges")}
                      style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                    >
                      Total Logistics and Repair Support Fees{sortConfig.key === "totalServiceCharges" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                    </th>
                    <th
                      onClick={() => handleSort("gst")}
                      style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                    >
                      GST {sortConfig.key === "gst" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                    </th>
                    <th
                      onClick={() => handleSort("total")}
                      style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                    >
                      Total {sortConfig.key === "total" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                    </th>
                    <th
                      onClick={() => handleSort("financeStatus")}
                      className="border-end"
                      style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                    >
                      Finance Status {sortConfig.key === "financeStatus" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                    </th>
                    <th>Invoice</th>

                  </tr>
                </thead>
                <tbody>
                  {[...currentInvoices]
                    .sort((a, b) => {
                      if (!sortConfig.key) return 0;
                      const aValue = a[sortConfig.key] || "";
                      const bValue = b[sortConfig.key] || "";

                      if (typeof aValue === "number" && typeof bValue === "number") {
                        return sortConfig.direction === "asc" ? aValue - bValue : bValue - aValue;
                      }

                      return sortConfig.direction === "asc"
                        ? aValue.toString().localeCompare(bValue.toString())
                        : bValue.toString().localeCompare(aValue.toString());
                    })
                    .map((invoice, index) => (

                      <tr
                        key={index}
                        className="text-center border-bottom network_td_item"
                      >
                        <td className="border-start align-middle">
                          <IconButton onClick={() => handleViewRow(invoice)}>
                            <FaEye
                              className="text-purple review_fa_eye"
                              style={{ cursor: "pointer" }}
                              size={20}
                            />
                          </IconButton>
                        </td>
                        <td className="align-middle">
                          <IconButton onClick={() => navigate(`/logs/${invoice.batchNo}`)}>
                            <DescriptionIcon fontSize="medium" className="text-blue-600 cursor-pointer" />
                          </IconButton>
                        </td>
                        <td className="align-middle">
                          {invoice.batchNo || "--"}
                        </td>
                        <td className="align-middle">
                          {invoice.vendorName || "--"}
                        </td>
                        <td className="align-middle">
                          {invoice.caseCount || "--"}
                        </td>
                        {/* <td className="align-middle">
                        {formatDate(invoice.creationDate)}
                      </td>
                      <td className="align-middle">
                        {formatDate(invoice.closureDate) || "--"}
                      </td> */}
                        <td className="align-middle">
                          {invoice.totalRepairCharges || "--"}
                        </td>
                        <td className="align-middle">
                          {invoice.totalServiceCharges || "--"}
                        </td>
                        <td className="align-middle">
                          {invoice.gst || "--"}
                        </td>
                        <td className="align-middle">
                          {invoice.total
                            ? `${invoice.total
                              .split(",")
                              .map((val) => parseFloat(val.trim()))
                              .reduce(
                                (acc, num) => acc + (isNaN(num) ? 0 : num),
                                0
                              )
                              .toLocaleString()}`
                            : "--"}
                        </td>
                        <td className="align-middle border-end">
                          <div className="network_table_main">
                            <span
                              className={`custom-dropdown-toggle network_table_approve ${invoice.financeStatus
                                ? getStatusBadgeClass(invoice.financeStatus)
                                : ""
                                }`}
                            >
                              {invoice.financeStatus || "--"}
                            </span>
                          </div>
                        </td>
                        <td className="align-middle">
                          {invoice.pdf ? (
                            /\.(jpe?g|png|gif|bmp|webp)$/i.test(invoice.pdf) ? (
                              <a
                                href={invoice.pdf}
                                target="_blank"
                                rel="noopener noreferrer"
                                download
                              >
                                <img
                                  src={invoice.pdf}
                                  alt="Invoice Image"
                                  style={{ height: "40px", width: "40px", objectFit: "cover", borderRadius: "4px", cursor: "pointer" }}
                                />
                              </a>
                            ) : (
                              <a
                                href={invoice.pdf}
                                target="_blank"
                                rel="noopener noreferrer"
                                download
                              >
                                <img
                                  src={pdfimage}
                                  alt="Download PDF"
                                  style={{ height: "24px", cursor: "pointer" }}
                                />
                              </a>
                            )
                          ) : (
                            "--"
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>
          )}
          <div className="d-flex justify-content-between align-items-center pagination-container network_previous">
            <button
              className="network_previous"
              onClick={handlePrevious}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span className="page-info">
              Page {currentPage} of {totalPages}
            </span>
            <button
              className="network_previous"
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      </div>
      <QuaryPopUp
        show={showHoldModal}
        handleClose={() => setShowHoldModal(false)}
        selectedData={selectedRowData}
      />
    </div>
  );
}

export default QueryCases;